import { Bot } from '@orgus/ui/icons';
import { ActivityPanel, AgentsPanel } from '../../ai/ActivityPanels.tsx';
import { ConnectPanel } from '../../ai/ConnectPanel.tsx';
import { TiersPanel } from '../../ai/TiersPanel.tsx';
import { useAiState } from '../../ai/useAiData.ts';
import type { SettingsSection } from '../registry.ts';

function AiAgents() {
  const { load, live, retry } = useAiState();
  return (
    <div className="flex flex-col gap-4">
      <ConnectPanel />
      <AgentsPanel load={load} live={live} retry={retry} />
      <ActivityPanel load={load} live={live} retry={retry} />
      <TiersPanel />
    </div>
  );
}

const section: SettingsSection = {
  id: 'ai-agents',
  title: 'AI agents',
  description: 'Let an AI agent watch and run Orgus through MCP, inside the limits you set.',
  order: 50,
  group: 'agents',
  keywords: ['mcp', 'ai', 'agent access', 'tiers'],
  icon: Bot,
  Component: AiAgents,
};
export default section;
